/* global App */
const { warn } = require('util/logger')

const DEFAULT_DIGITS = 2
const DEFAULT_FORMAT = '{sign}{number} {currency}'
const DEFAULT_SYMBOL = 'UNKNOWN'

module.exports = {
    getCurrencyConfig (currency) {
        const config = App.Constants.CURRENCY_FORMAT

        if (config[currency]) {
            return config[currency]
        }
        return null
    },

    getFractionDigits (currency) {
        const config = this.getCurrencyConfig(currency)
        return config ? config.fractionDigits : DEFAULT_DIGITS
    },

    getCurrencyFormat (currency) {
        const config = this.getCurrencyConfig(currency)
        return config ? config.format : DEFAULT_FORMAT
    },

    getCurrencySymbol (currency) {
        const config = this.getCurrencyConfig(currency)
        return config ? config.symbol : DEFAULT_SYMBOL
    },

    formatCurrency (number, currency, sign) {
        return this.getCurrencyFormat(currency)
            .replace('{number}', number)
            .replace('{sign}', sign < 0 ? '-' : '')
            .replace('{currency}', this.getCurrencySymbol(currency))
    },

    // @deprecated
    asDecimal (number, precision) {
        precision = precision || 2;
        var numberToFormat = parseFloat(parseFloat(number).toFixed(precision));
        return numberToFormat.toLocaleString('es', {
            minimumFractionDigits: 2
        })
    },
    /**
     * @param number
     * @param currency
     * @param options
     *   - only_symbol: return only the currency symbol, without number
     *   - with_symbol: return number with currency symbol
     */
    toCurrency (number, currency, options = {}) {
        if (number === null) {
            return ''
        }

        if (currency === null) {
            return number
        }

        const locale = options.locale || App.Constants.LANGUAGE
        const formatter = new Intl.NumberFormat(locale, {
            minimumFractionDigits: this.getFractionDigits(currency),
            maximumFractionDigits: this.getFractionDigits(currency),
        })

        if (options.with_symbol) {
            return this.formatCurrency(
                formatter.format(Math.abs(number)),
                currency,
                Math.sign(number)
            )
        }

        if (options.only_symbol) {
            return this.getCurrencySymbol(currency)
        }

        return formatter.format(number)
    },

    validate (number, config) {
        return this.getNumberRegex(config || App.Constants.NUMBER_FORMAT).test(number)
    },

    // @deprecated
    parseFloat (number) {
        warn('NumberFormatter.parseFloat - Deprecated method!')
        if (isNaN(number)) {
            return parseFloat(number.replace(/\./g, '').replace(',', '.'))
        }
        return parseFloat(number)
    },

    getNumberRegex: function (config) {
        var decimalSeparator = config ? config.DECIMAL_SEPARATOR_SYMBOL : ','
        var thousandSeparator = config ? config.THOUSAND_SEPARATOR_SYMBOL : '.'
        return new RegExp("^-?\\d+(\\" + thousandSeparator + "\\d{3})?(\\" + decimalSeparator + "\\d+)?$")
    },
};
